import type { Nullish } from '@iheartjane/types';

export const getTodaysScheduleHours = (schedule: {
  curbside?: Nullish<{
    closing: Nullish<string>;
    opening: Nullish<string>;
  }>;
  delivery?: Nullish<{
    closing: Nullish<string>;
    opening: Nullish<string>;
  }>;
  pickup?: Nullish<{
    closing: Nullish<string>;
    opening: Nullish<string>;
  }>;
}) => {
  const { pickup, delivery, curbside } = schedule;
  const pickupHours =
    pickup?.opening?.length && pickup?.closing?.length
      ? `${pickup.opening} - ${pickup.closing}`
      : null;
  const deliveryHours =
    delivery?.opening?.length && delivery?.closing?.length
      ? `${delivery.opening} - ${delivery.closing}`
      : null;
  const curbsideHours =
    curbside?.opening?.length && curbside?.closing?.length
      ? `${curbside.opening} - ${curbside.closing}`
      : null;

  return {
    pickupHours,
    deliveryHours,
    curbsideHours,
  };
};
